import { pathOr } from 'ramda'

export const getPauseInformation = state => {
  return pathOr(
    null,
    ['api', 'pauseInformation', 'data', 'data', 'pauseData', 0],
    state
  )
}
